export default __webpack_public_path__ + "122c85f043d51d0b694da8dd32393273.png";